import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { Button, CardActionArea, CardActions, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import Breadcrumbs from "../../components/Common/Breadcrumb"
import courseImg from "../../assets/images/Digital-Marketing.jpg";
import webimg6 from "../../assets/images/webimg6.jpg";
import webimg2 from "../../assets/images/webimg2.jpg";
import { Link, useHistory } from "react-router-dom";
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import axios from 'axios';
import { Col, Row, CardText, CardBody, CardTitle } from "reactstrap";
import Marquee from "react-fast-marquee";
import "../../helpers/helper";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs(props) {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tid, setTid] = useState(null);
  const [address, setAddress] = useState(null);
  const [file, setFile] = useState();
  const [value, setValue] = useState(0);
  const [invoices, setInvoice] = useState([]);
  const [total, setTotal] = useState(0);
  const [selectedCourses, setSelectedCourses] = useState([]); // Update for multiple selections

  const navigateToModule = async (courseId) => {
    const certificate = await axios.get(global.config.URL.api.lms + 'download-onsite-certificate/' + courseId);
    const win = window.open(certificate.data.pdf, '_blank');
    if (win != null) {
      win.focus();
    }
  };

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${global.config.Token}`;

    const getData = async () => {
      const invoices = await axios.get(global.config.URL.api.lms + 'my-onsite-certificates');
      setInvoice(invoices.data.courses);
      setLoading(false)
      calculateTotalAmount([]); // Initial call with an empty selection
    };

    getData();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSelectedCourses([]);
    setTotal(0)
  };

  const calculateTotalAmount = (selectedCourses) => {
    let total = 0;
    const numberOfCertificates = selectedCourses.length;

    if (numberOfCertificates === 1) {
      total = 600;
    } else if (numberOfCertificates === 2) {
      total = 800;
    } else if (numberOfCertificates === 3) {
      total = 1000;
    } else if (numberOfCertificates === 4) {
      total = 1200;
    } else if (numberOfCertificates >= 5) {
      total = 1500;
    }
    setTotal(total);
  };

  function handleSubmit(event) {
    event.preventDefault();
    const url = global.config.URL.api.lms + 'request-certificate';
    const formData = new FormData();
    formData.append('img', file);
    formData.append('tr_id', tid);
    formData.append('address', address);
    selectedCourses.forEach((courseId, index) => {
      formData.append(`course_ids[${index}]`, courseId);
    });
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    axios.post(url, formData, config).then((response) => {
      setTid(null)
      setAddress('')
      setFile(null)
      setSelectedCourses([])
      if (response.data.success) {
        setError("Successfully Submitted");
       
      } else if (response.data.success === false) {
        setError(response.data.message);
      }
    });
  }

  const handleChangeCourse = (event) => {
    const { value } = event.target;
    setSelectedCourses(value);
    calculateTotalAmount(value); // Update total whenever selected courses change
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Breadcrumbs title="Certificate" breadcrumbItem="Select Course To Get Certificate" />

        <Box sx={{ width: '100%' }}>
         

          
             {invoices ? invoices.length > 0 ? 
              <Row>
                {invoices.map((course, j) => (
                  <Col md={4} sm={6} className="mt-3" key={j}>
                    <Card sx={{ maxWidth: 345 }}>
                      <CardActionArea>
                        <CardMedia
                          component="img"
                          height="140"
                          image={global.config.URL.img.public + course.course.course_detail.img}
                          alt="course image"
                        />
                        <CardContent>
                          <Typography gutterBottom variant="h6" className='heading' component="div">
                            {course.course.name}
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                      <CardActions>
                        <Button size="small" onClick={() => navigateToModule(course.id)} className='btnn'>
                          <i className='fa fa-arrow-down'></i> &nbsp; Download Certificate
                        </Button>
                      </CardActions>
                    </Card>
                  </Col>
                ))}
               {/* here */}
              </Row>
            
           : <Col md={12}><Card body className='p-3'><CardText><h2>Dear PFTPians,</h2> You will be able to access your certificate after Project Result.</CardText></Card></Col> :
            <SkeletonAnimation />
                              }
        </Box>
      </div>
    </React.Fragment>
  );
}

function SkeletonAnimation() {
  return (
    <Row>
      {[...Array(3)].map((_, i) => (
        <Col md={4} sm={6} className="mt-3" key={i}>
          <Stack spacing={1}>
            <Skeleton animation="wave" variant="rectangular" width={'100%'} height={140} />
            <Skeleton width="60%" />
            <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
            <Skeleton variant="text" height={20} sx={{ fontSize: '1rem' }} />
          </Stack>
        </Col>
      ))}
    </Row>
  );
}
